module.exports = __webpack_public_path__ + "img/tag_back.39fe5efb.svg";